"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectType;
(function (ProjectType) {
    ProjectType["FOLDER"] = "FOLDER";
    ProjectType["PROJECT"] = "PROJECT";
})(ProjectType = exports.ProjectType || (exports.ProjectType = {}));
//# sourceMappingURL=ProjectType.js.map